// API base URL. Empty string → same-origin requests (works for dev with the
// Vite proxy, and for prod if CloudFront routes /api/* to the API Gateway).
// To call the API on a different subdomain in prod, set
// `VITE_API_BASE_URL=https://api.heredajo.com` at build time.
export const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "";
